import * as React from "react";

export const RewardPanelImage = () => {
  return (
    <section className="marketing">
      <div
        className="div-reward-full-image"
        onClick={() => {
          window.location.href = "/rewards/";
        }}
      >
        <img className="reward-panel-full-image" alt="rewards" />
      </div>
    </section>
  );
};
